import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const MB_SVG_Check = React.memo((props: {
    /**
     * The size of the component.
     */
    size?: number,

    /**
     * The color of the component.
     */
    color?: string,

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>
}) => {
    return (
        <View style={props.containerStyle}>
            <Svg
                width={props.size ?? 10}
                height={props.size ? (props.size * (8 / 10)) : 8}
                viewBox="0 0 10 8"
                fill="none"
            >
                <Path
                    d="M9.333 1.1L3.65 6.783 1.066 4.2"
                    stroke={props.color ?? "#ffffff"}
                    strokeWidth={1.03333}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </Svg>
        </View>
    );
});

export { MB_SVG_Check };
